import { useTranslation } from "react-i18next";
import { useFormik } from "formik";
import Text from "../../../molecules/content/Text";
import FloatingInputField from "../../../molecules/formControls/inputField/FloatingInputField";
import PasswordRuleList from "../../../molecules/formControls/validation/PasswordRuleList";
import DefaultButton from "../../../atoms/buttons/DefaultButton";
import ForgotPasswordValidation from "./validation";

const ForgotPasswordForm = ({ onSubmit }) => {
  const { t } = useTranslation();

  const initialValues = {
    code: "",
    password: "",
    passwordConfirm: "",
  };

  const formik = useFormik({
    initialValues,
    validationSchema: ForgotPasswordValidation(t),
    onSubmit,
  });

  return (
    <form
      className="flex flex-col gap-8"
      autoComplete="off"
      onSubmit={formik.handleSubmit}
    >
      <Text variant="h2" className="flex justify-center text-vestelColor">
        {t("forgotPassword.title")}
      </Text>
      <FloatingInputField
        id="password"
        name="password"
        label={t("forgotPassword.password")}
        required
        type="password"
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        value={formik.values.password}
        formikTouched={formik.touched.password}
        error={formik.errors.password}
      />
      <PasswordRuleList password={formik.values.password} />
      <FloatingInputField
        id="passwordConfirm"
        name="passwordConfirm"
        label={t("forgotPassword.passwordAgain")}
        required
        type="password"
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        value={formik.values.passwordConfirm}
        formikTouched={formik.touched.passwordConfirm}
        error={formik.errors.passwordConfirm}
        showDefaultValidation
      />
      <Text variant="small" className="text-center">
        {t("requestCode.description")}
      </Text>
      <DefaultButton
        type="submit"
        label={t("forgotPassword.submit")}
        disabled={!(formik.isValid && formik.dirty) || formik.isSubmitting}
      />
    </form>
  );
};

export default ForgotPasswordForm;
